import apiClient from '../../guardian-dashboard/api/client';

export const fetchCurriculum = async (childId) => {
  const response = await apiClient.get(`/children/${childId}/curriculum`);
  return response.data;
};

export const reorderActivity = async (childId, activityId, prevActivityId, nextActivityId) => {
  const response = await apiClient.post(`/children/${childId}/curriculum/reorder`, {
    activity_id: activityId,
    prev_activity_id: prevActivityId,
    next_activity_id: nextActivityId
  });
  return response.data;
};

export const deleteActivity = async (childId, activityId) => {
  const response = await apiClient.delete(`/children/${childId}/curriculum/activities/${activityId}`);
  return response.data;
};
